export const ACTIONS = {
    OPEN_COMPLETION_MODAL: "OPEN_COMPLETION_MODAL",
    CLOSE_COMPLETION_MODAL: "CLOSE_COMPLETION_MODAL"
}

export const openModal = (courseTitle, launchParams, orgId, studentId) => ({
    type: ACTIONS.OPEN_COMPLETION_MODAL,
    payload: {
        courseTitle,
        launchParams,
        orgId,
        studentId
    }
})

export const closeModal = () => ({
    type: ACTIONS.CLOSE_COMPLETION_MODAL
})

export default {
    openModal,
    closeModal
}